import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

function renderTurnstile() {
  const turnstileElement = document.querySelector(".cf-turnstile");
  const submitButton = document.querySelector(".turnstile-checked");

  if (!turnstileElement || !submitButton) return;

  // Desabilita o botão novamente quando a página é renderizada (útil após erros de validação)
  submitButton.setAttribute("disabled", "disabled");

  function enableClosestSubmitButton() {
    submitButton.removeAttribute("disabled");
  }

  if (turnstileElement && window.turnstile) {
    const siteKey = turnstileElement.dataset.sitekey;

    // Remove o Turnstile anterior se existir (importante para reinicialização após erros)
    const existingWidgetId = turnstileElement.getAttribute("data-widget-id");
    if (existingWidgetId) {
      try {
        window.turnstile.remove(existingWidgetId);
      } catch (e) {
        // Ignora erros se o widget não existir mais
      }
    }

    // Limpa o conteúdo do elemento antes de renderizar novamente
    turnstileElement.innerHTML = "";

    const widgetId = window.turnstile.render(turnstileElement, {
      sitekey: siteKey,
      callback: () => {
        enableClosestSubmitButton();
      }
    });

    // Armazena o widget ID para poder removê-lo depois se necessário
    if (widgetId) {
      turnstileElement.setAttribute("data-widget-id", widgetId);
    }
  }
}

document.addEventListener("turbo:load", function() {
  renderTurnstile();
});

document.addEventListener("turbo:frame-load", function() {
  renderTurnstile();
});

// Adiciona listener para turbo:render para garantir que o Turnstile seja reinicializado após erros de validação
document.addEventListener("turbo:render", function() {
  renderTurnstile();
});

export { application }
